import { Component, Input, OnInit, OnDestroy } from '@angular/core';

@Component({
  selector: 'app-metro-carousel',
  templateUrl: './metro-carousel.component.html',
  standalone:false
})
export class MetroCarouselComponent implements OnDestroy, OnInit {
  @Input() images: string[] = [];
  @Input() autoPlay: boolean = true;
  @Input() interval: number = 4000;

  currentIndex = 0;
  hasContent = false;

  private timer: any;

  ngOnInit() {
    if (this.autoPlay) this.startAutoPlay();
  }

  ngOnDestroy() {
    this.stopAutoPlay();
  }

  next() {
    this.currentIndex = (this.currentIndex + 1) % this.images.length;
  }

  prev() {
    this.currentIndex =
      (this.currentIndex - 1 + this.images.length) % this.images.length;
  }

  startAutoPlay() {
    this.timer = setInterval(() => this.next(), this.interval);
  }

  stopAutoPlay() {
    if (this.timer) clearInterval(this.timer);
  }
}
